export const clickOutside = {
    beforeMount(el, binding) {
        el.clickOutsideEvent = event => {
            const path = typeof event.composedPath === 'function' ? event.composedPath() : null;
            const inside = path ? path.includes(el) : el === event.target || el.contains(event.target);
            if (!inside) {
                binding.value(event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
        document.body.addEventListener('contextmenu', el.clickOutsideEvent);
    },
    unmounted(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
        document.body.removeEventListener('contextmenu', el.clickOutsideEvent);
    }
};
